import { React, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { handleLoaderEvent } from "../utils/LoaderEmitter";
import { getClientSkills } from "../utils/Api";
import { deactivateClientSkill } from "../utils/Api";

import ReactPaginate from "react-paginate";

import ClientNavigation from "./ClientNavigation";

import { iconAssets } from "../assets/theme/theme";
import { Image } from "@fluentui/react-northstar";
import { Modal } from "react-bootstrap";

import "../styles/ViewSkills.css";

const ClientSkills = () => {
  const [skills, setSkills] = useState([]);
  const [itemsPerPage, setitemsPerPage] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentItems, setCurrentItems] = useState(null);
  const [clientName, setClientName] = useState([]);
  const [confirmationModal, setConfirmationModalShow] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState("");
  const [deactivateSkillStatus, setDeactivateSkillStatus] = useState(false);

  let { id } = useParams();

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(skills.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(skills.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, skills]);

  useEffect(() => {
    (async () => {
      handleLoaderEvent.emit("loader", true);
      setClientName(localStorage.getItem("clientName"));
      let skillsData = await getClientSkills(id);
      setSkills(skillsData.skillList);
      handleLoaderEvent.emit("loader", false);
    })();
  }, [deactivateSkillStatus]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % skills.length;
    setItemOffset(newOffset);
  };
  const confirmationModalShow = (skillName, subscriptionProductSkillId) => {
    setSelectedSkill({ skillName: skillName, subscriptionProductSkillId: subscriptionProductSkillId });
    setConfirmationModalShow(true);
  };
  const confirmationModalClose = () => {
    setConfirmationModalShow(false);
  };
  const submitDeactivateSkill = async () => {
    let deactivatedSkill = await deactivateClientSkill(id, selectedSkill.subscriptionProductSkillId);
    if (deactivatedSkill) {
      confirmationModalClose();
      toast.info("Skill successfully deactivated");
      setDeactivateSkillStatus((prev) => !prev);
      handlePageClick({ selected: 0 });
    }
  };
  const skillRows = (currentItems) =>
    currentItems?.map((skill) => {
      return (
        <tr className="table-content border-bottom table-row" key={skill.id}>
          <td style={{ width: "30%" }} className="p-3">
            {skill.skillName}
            {skill.isRoot ? <span className="badge rounded-pill bg-success ms-2 p-1 px-2">{skill.isRoot ? "Root" : ""}</span> : ""}
          </td>
          <td style={{ width: "20%" }} className="p-3">
            {skill.subscriptionProductSkillCreatedDatetime.split("T")[0]}
          </td>
          <td style={{ width: "20%" }} className="p-3">
            {skill.subscriptionProductSkillStatus === 1 ? "Active" : "Inactive"}
          </td>
          <td style={{ width: "30%" }} className="p-3">
            {!skill.isRoot &&
              (skill["subscriptionProductSkillStatus"] ? (
                <button className="deactivate-button p-2 px-3" onClick={() => confirmationModalShow(skill.skillName, skill.subscriptionProductSkillId)}>
                  Deactivate
                </button>
              ) : (
                <button className="activate-button p-2 px-3">Activate</button>
              ))}
          </td>
        </tr>
      );
    });

  const skillTable = () => {
    return (
      <>
        <table className="container-fluid p-0">
          <thead>
            <tr className="table-header mb-4">
              <th style={{ width: "30%" }}>Skill Name</th>
              <th style={{ width: "20%" }}>Created Date</th>
              <th style={{ width: "20%" }}>Status</th>
              <th style={{ width: "30%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>{skillRows(currentItems)}</tbody>
        </table>
      </>
    );
  };

  return (
    <>
      <div>
        <ClientNavigation id={id} selectedTab={"Manage Skills"}></ClientNavigation>
        <div className="row p-0 m-0 screen-header mt-4 mb-3 p-1">
          <div className="col content-title ps-4">Skills</div>
          <div className="col-auto cursor">
            <div className="row p-0 m-0 cursor-pointer">
              <div className="col-auto pe-1 d-flex align-items-center add-skill-disabled">
                <Image src={iconAssets.add} alt="" className="add-icon" />
              </div>
              <div className="col-auto ps-0 content-title-sub-text d-flex align-items-center add-skill-disabled">Add Skill</div>
            </div>
          </div>
        </div>
        <div className="container-fluid p-0">
          <div className="skill-table">{skillTable(skills)}</div>

          <div className="row p-0 m-0 mt-4">
            <div className="col-auto px-2 d-flex align-items-center">Rows Per Page</div>
            <div className="col-auto px-2 d-flex align-items-center">
              <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                {itemsPerPage}
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <div className="dropdown-item" onClick={() => setitemsPerPage(5)}>
                    5
                  </div>
                </li>
                <li>
                  <div className="dropdown-item" onClick={() => setitemsPerPage(10)}>
                    10
                  </div>
                </li>
              </ul>
            </div>
            <div className="col p-0 d-flex justify-content-end">
              <ReactPaginate
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={4}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="<"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
              />
            </div>
          </div>
        </div>

        <Modal className="activation-modal" show={confirmationModal} onHide={confirmationModalClose}>
          <Modal.Body>
            <Modal.Title className="status-modal-title text-center">Confirm Action</Modal.Title>
            <div className="status-modal-sub-title mt-4 text-center">Are you sure you want to deactivate {selectedSkill.skillName} skill ?</div>
            <div className="status-modal-sub-title mt-4 text-center">All data assocaited with the skill will be deleted permanently.</div>

            <div className="d-flex justify-content-end mt-5">
              <button className="cancel-button p-2 px-4 me-3" onClick={confirmationModalClose}>
                Cancel
              </button>
              <button className="save-button p-2 px-4" onClick={submitDeactivateSkill}>
                Deactivate
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
export default ClientSkills;
